import i18nIns from 'i18next';
import {initReactI18next} from 'react-i18next';

import LanguageDetector from 'i18next-browser-languagedetector';

import {ClientStorage} from '../utils';

import en from './localizeFiles/en';
import vi from './localizeFiles/vi';


interface IResource {
  [x: string]: {
    translation: object
  }
}

const resources: IResource = {
  en: {
    translation: en
  },
  vi: {
    translation: vi
  }
};


//should we load localization through xhr??

i18nIns
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({  // for all options read: https://www.i18next.com/overview/configuration-options
    resources: resources,
    fallbackLng: 'en',
    //debug: true,
    detection: {
      name: 'payment',

      lookup() {
        return ClientStorage.lang || 'en'
      },

      cacheUserLanguage(lang: string) {
        // store it
        ClientStorage.lang= lang
      }
    }
  });


export default i18nIns;